import { render, staticRenderFns } from "./UnionGoodsForm.vue?vue&type=template&id=231c8805"
import script from "./UnionGoodsForm.vue?vue&type=script&lang=js"
export * from "./UnionGoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports